"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author Sean sean.snow@live.com
 * @date 2015/12/25
 */

var ISOHeader = function () {
  function ISOHeader() {
    _classCallCheck(this, ISOHeader);
  }

  _createClass(ISOHeader, [{
    key: "pack",


    /**
     * Return this header as byte array.
     */
    value: function pack() {}

    /**
     * Create a new ISOHeader from a byte array.
     *
     * @return Number The Number of bytes consumed.
     */

  }, {
    key: "unpack",
    value: function unpack(b) {}

    /**
     * Set the Destination address in this ISOHeader.
     */

  }, {
    key: "setDestination",
    value: function setDestination(dst) {}

    /**
     * Return the destination address in this ISOHeader.
     * returns null if there is no destination address
     */

  }, {
    key: "getDestination",
    value: function getDestination() {}

    /**
     * Set the Source address in this ISOHeader.
     */

  }, {
    key: "setSource",
    value: function setSource(src) {}

    /**
     * Return the source address in this ISOHeader.
     * returns null if there is no source address
     */

  }, {
    key: "getSource",
    value: function getSource() {}

    /**
     * return the number of bytes in this ISOHeader
     */

  }, {
    key: "getLength",
    value: function getLength() {}

    /**
     * Swap the source and destination addresses in this ISOHeader
     * (if they exist).
     */

  }, {
    key: "swapDirection",
    value: function swapDirection() {}
  }, {
    key: "clone",


    /**
     * Allow object to be cloned.
     */
    value: function clone() {}
  }]);

  return ISOHeader;
}();

exports.default = ISOHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/ISOHeader.js
// module id = 37
// module chunks = 0